export enum Environment {
  development = 'development', // this should be called "staging"
  production = 'production',
  preview = 'preview',
  beta = 'beta',
  local = 'local',
}

export const isProdOrBeta = () => {
  return [Environment.production, Environment.beta].includes(environment())
}

const productionHosts = [
  'app.breakoutlearning.com',
  'cases.breakoutlearning.com',
  'beta.breakoutlearning.com',
  'beta-new.breakoutlearning.com',
  'breakout-learning-dev--test-namespaced-beta-deploy-xobjl65l.web.app',
]

const devHosts = ['dev.breakoutlearning.com', 'dev-new.breakoutlearning.com']

let _env: Environment | null = null

export function environment(): Environment {
  // Cache the environment
  if (_env) return _env

  _env = resolveEnvironment()

  return _env
}

export function inE2E(): boolean {
  return import.meta.env.MODE === 'e2e'
}

export function inBeta(): boolean {
  return environment() === Environment.beta
}

export function inDevelopment(): boolean {
  return environment() === Environment.development
}

export function inDevelopmentOrPreview(): boolean {
  const env = environment()
  return env === Environment.development || env === Environment.preview
}

export function inProduction(): boolean {
  return environment() === Environment.production
}

export function inPreview(): boolean {
  return environment() === Environment.preview
}

export function inLocalDev(): boolean {
  return environment() === Environment.local
}

function resolveEnvironment(): Environment {
  const hostname = window.location.hostname

  if (window.location.hostname === 'localhost') return Environment.local

  if (window.location.hostname === 'beta.breakoutlearning.com') {
    return Environment.beta
  }

  if (productionHosts.includes(hostname)) return Environment.production

  if (devHosts.includes(hostname)) return Environment.development

  // PR previews are hosted on *.web.app
  if (hostname.endsWith('.web.app')) return Environment.preview

  // otherwise, assume we're in development
  return Environment.development
}

const envColors = {
  [Environment.development]: '#D15924',
  [Environment.production]: undefined, // do nothing for production
  [Environment.preview]: '#FFF0E5',
  [Environment.beta]: '#CCCCCC',
  [Environment.local]: undefined, // do nothing for local
}

export function currentEnvColor(): string | undefined {
  const env = environment()
  return envColors[env]
}

export function installEnvironmentBackground() {
  const color = currentEnvColor()
  if (color) {
    document.body.style.backgroundColor = color
  }
}
